const teacherEvaluation = {
  path: 'teacherEvaluation/:myClassId',
  component: resolve => require(['../../../../../components/pages/student_user/comprehensiveEvaluation/teacherEvaluation'], resolve),
  props: true
}
export default teacherEvaluation
